import app from "../common/app";

app.render_page("default");
